import styled from 'styled-components';
import { defaultBackground } from '../../../../styles/style-guide';

export const ButtonStartOnboarding = styled.button<{ $backgroundColor?: string; $backgroundHover?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 0.25rem;
  background-color: ${({ $backgroundColor }) => $backgroundColor || defaultBackground.primary};
  font-size: 1rem;
  line-height: 1.5rem;
  color: rgb(255 255 255 / 1);
  &:hover {
  background-color: ${({ $backgroundHover }) => $backgroundHover || defaultBackground.hover};
  }
  &:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
  }
  @media (min-width: 768px) {
    width: 340px;
  }
}`;
